import React, { Fragment, useState } from "react";
import { Modal, Button, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { Row, Form, Col } from "react-bootstrap"

const NewProjectModel = (props) => {
    const { show, handleClose, handleSave, data, setData } = props;
    const [error, setError] = useState('')

    const changeData = (key, e) => {
        var regex = /[!@#$%^&*(),?":{}|<>]/;
        const value = e.target.value

        if (error !== '') setError('')

        if (key === 'project_name') {
            !regex.test(value)
                ?
                setData({ ...data, [key]: value })
                :
                setError('Project name should not contain special characters.')
        }

        if (key === 'description') {
            setData({ ...data, [key]: value })
        }
    }

    return (
        <Fragment>
            <Modal isOpen={show} toggle={handleClose} fullscreen={true} size="md">
                <ModalHeader toggle={handleClose}>Create New Project</ModalHeader>
                <ModalBody>
                    <Form>
                        {/* <Row className="mb-3"> */}
                        <Form.Group controlId="formGridEmail">
                            <Form.Label>Nom du Projet</Form.Label>
                            <Form.Control value={data.project_name} onChange={(e) => changeData("project_name", e)} type="text" />
                            {error !== '' && <Form.Text className="project-text text-error">{error}</Form.Text>}
                            <Form.Text className="project-text">Le nom du projet est utilisé pour référencer les ensembles de données entre projets. Il ne peut pas être modifié une fois le projet créé.</Form.Text>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formGridAddress1">
                            <Form.Label>Description du Projet</Form.Label>
                            <Form.Control value={data.description} onChange={(e) => changeData("description", e)} as="textarea" rows={3} />
                        </Form.Group>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSave}>Save</Button>
                    <Button color="light" onClick={handleClose}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    )
}

export default NewProjectModel;